<div class="msg-wrap">
  <header class="msg-head">
    <div class="msg-title-row">
      <span class="msg-title-icon"><i class="fa fa-truck"></i></span>
      <h1 class="msg-title">Dispatch</h1>
    </div>
    <p class="msg-subtitle">Consignments a gallery has accepted and is waiting for you to send.</p>
  </header>

  @if (loaded && consignments.length === 0) {
    <div class="msg-empty">
      <i class="fa fa-check-circle"></i>
      <p>Nothing waiting to be dispatched.</p>
    </div>
  }

  <div class="msg-list">
    @for (c of consignments; track c.Guid) {
      <div class="msg-card">
        <div class="msg-logo msg-logo-icon"><i class="fa fa-archive"></i></div>
        <div class="msg-info">
          <div class="msg-name">{{ consignmentLabel(c) }}</div>
          @if (c.GalleryName) { <div class="msg-meta"><i class="fa fa-university"></i> {{ c.GalleryName }}</div> }
          <div class="msg-meta"><i class="fa fa-cubes"></i> {{ c.NumberOfConsignmentProducts }} piece(s)</div>
        </div>
        <div class="msg-actions">
          <button class="msg-btn msg-primary" (click)="dispatch(c)"><i class="fa fa-truck"></i> Mark as dispatched</button>
        </div>
      </div>
    }
  </div>
</div>
